import { Record, List } from "immutable";
import { CIRCUIT_TYPES } from "src/infinode/constants/circuit";
import { DEMAND_TYPES } from "src/infinode/constants/demand";
import { GENERIC_NONE_VALUE } from "src/infinode/constants/genericValues";

const CircuitRecord = Record({
  id: null,
  key: null,
  name: "",
  circuitType: CIRCUIT_TYPES.NORMAL,
  zoneId: null,
  category: List(),
  categoryLevel1: "",
  categoryLevel2: "",
  deviceId: "",
  deviceCircuit: GENERIC_NONE_VALUE,
  // demand
  demandOn: false,
  demandType: DEMAND_TYPES.FIXED,
  demandInterval: 30
});

const createCircuitRecord = (circuit, zoneId) => {
  const { categoryLevel1, categoryLevel2 } = circuit;
  console.trace('create');
  console.log(categoryLevel1);
  return CircuitRecord(circuit).withMutations(cm => {
    cm.set("zoneId", zoneId);
    // To add category
    if (categoryLevel1) {
      cm.update("category", cat => {
        let newCat = cat.push(categoryLevel1);
        return categoryLevel2 ? newCat.push(categoryLevel2) : newCat;
      });
    }
    // Demand
    if (circuit.circuitDemand) {
      cm.set("demandOn", circuit.circuitDemand.isOn);
      if (circuit.circuitDemand.type) {
        cm.set("demandType", circuit.circuitDemand.type);
      }
      cm.set("demandInterval", circuit.circuitDemand.interval);
    }
  });
};

export { createCircuitRecord };

export default CircuitRecord;
